export function createCommentsApi(fetchApi) {
    return {
        clientEmail(issueId) {
            return fetchApi(`/issues/${issueId}/comments/client-email`);
        },
        retryClientEmail(issueId, batchId) {
            return fetchApi(`/issues/${issueId}/comments/client-email/${batchId}/retry`, { method: 'POST' });
        },
        attachment(issueId, commentId, attachmentId) {
            return fetchApi(`/issues/${issueId}/comments/${commentId}/attachments/${attachmentId}`);
        },
        list(issueId) {
            return fetchApi(`/issues/${issueId}/comments`);
        },
        async create(issueId, body, opts) {
            if (body.attachments?.length) {
                // Older servers strip unknown JSON fields and still save the text.
                // Production probe 2026-09-23 at 831423f7 reproduced that file loss.
                // Confirm support before any write so all native surfaces retain a retryable draft.
                const support = await fetchApi(`/issues/${issueId}/comments/attachment-support`).catch(() => null);
                if (!support?.enabled)
                    throw new Error('File uploads are temporarily unavailable. Your draft is still here. Try again.');
            }
            // A stable Idempotency-Key lets a Retry after a LOST response return the
            // already-created row instead of writing a duplicate (server reads the
            // `Idempotency-Key` header). Only set the header when a key is supplied,
            // so existing 2-arg callers are unchanged.
            return fetchApi(`/issues/${issueId}/comments`, {
                method: 'POST',
                body: JSON.stringify(body),
                ...(opts?.idempotencyKey
                    ? { headers: { 'Idempotency-Key': opts.idempotencyKey } }
                    : {}),
            });
        },
        update(issueId, commentId, body) {
            return fetchApi(`/issues/${issueId}/comments/${commentId}`, {
                method: 'PATCH',
                body: JSON.stringify(body),
            });
        },
        async delete(issueId, commentId) {
            await fetchApi(`/issues/${issueId}/comments/${commentId}`, { method: 'DELETE' });
        },
    };
}
//# sourceMappingURL=comments.js.map